export default __webpack_public_path__ + "static/shop-image5-0755b95d8128f52db76ce3ccab759cc5.jpg";